import { render, staticRenderFns } from "./ChatbotPromptAdd.vue?vue&type=template&id=e7e23e14"
import script from "./ChatbotPromptAdd.vue?vue&type=script&lang=js"
export * from "./ChatbotPromptAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports